module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "category-card"
  }, [(_vm.category.cover_url) ? _c('div', {
    staticClass: "cover-wrapper"
  }, [_c('div', {
    staticClass: "img",
    style: ({
      backgroundImage: 'url( ' + _vm.category.cover_url + ')'
    })
  })]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "details",
    class: {
      'empty': !_vm.category.cover_url
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.category.name))]), _vm._v(" "), _c('p', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.category.description))]), _vm._v(" "), (_vm.category.publicity) ? _c('div', {
    staticClass: "public-link"
  }, [_c('i', {
    staticClass: "ppj-icon-link"
  }), _vm._v(_vm._s(_vm.$t('actions.category.publicity')) + "："), _c('a', {
    staticClass: "link",
    attrs: {
      "href": _vm.category.public_url,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.category.public_url))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "actions"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.$emit('edit')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('actions.category.edit')))])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7def82e4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/index/category/info.vue
// module id = 934
// module chunks = 3